module.exports = __webpack_public_path__ + "img/signup_image.3987528c.svg";